let g_ok = true;
let g_id = "123";
let p_price = 10;
let collections_list = [];
let mode = 0;
let t_scale = 1;
let g_area = 0;
let munit = 1;
let step = 1;
let type = 1;
let m_width = 0;
let m_length = 0;
let p_cnt = 0;
let manual_cut = 0;
let manual_cut_tapelength = 0;
let clip_id_list = [
  "49098750165333", // 0. High Tack Seaming Adhesive 
  "49098755408213", //1. Jointing Tape
  "49098773299541", // 2. Heavy Duty Weed Control Fabric Membrane
  "49098764026197", // 3. Weed Fabric Fixing Pegs
  "49098761470293", // 4. Galvanised Green Staple Pegs

  "49098762617173", // 5. 2-Part PU Adhesive
  "49098758979925", // 6. Galvinised Green Nails
  "49510380110165", // 7. 10mm Artificial Grass Underlay
  "49510405275989", // 8. 15mm Artificial Grass Underlay
  "49508722737493", // 9 Underlay Adhesive
];
let clip_cnt_list = Array(9).fill(0);
let clip_title_list = [
  "High Tack Seaming Adhesive", // 0. High Tack Seaming Adhesive 
  "Jointing Tape", //1. Jointing Tape
  "Heavy Duty Weed Control Fabric Membrane", // 2. Heavy Duty Weed Control Fabric Membrane
  "Weed Fabric Fixing Pegs", // 3. Weed Fabric Fixing Pegs
  "Galvanised Green Staple Pegs", // 4. Galvanised Green Staple Pegs
  "2-Part PU Adhesive", // 5. 2-Part PU Adhesive
  "Galvinised Green Nails", // 6. Galvinised Green Nails
  "10mm Artificial Grass Underlay", // 7. 10mm Artificial Grass Underlay
  "15mm Artificial Grass Underlay", // 8. 15mm Artificial Grass Underlay
  "Underlay Adhesive", // 9 Underlay Adhesive
];
let clip_unit_list = [
  "tubes", // 0. High Tack Seaming Adhesive 
  "m", //1. Jointing Tape
  "m2", // 2. Heavy Duty Weed Control Fabric Membrane
  "packs of 10 pegs", // 3. Weed Fabric Fixing Pegs
  "packs of 10 pegs", // 4. Galvanised Green Staple Pegs
  "packs", // 5. 2-Part PU Adhesive
  "packs of 20 nails",// 6. Galvinised Green Nails
  "m2", // 7. 10mm Artificial Grass Underlay
  "m2", // 8. 15mm Artificial Grass Underlay
  "tubes", // 9 Underlay Adhesive
];
let clip_price_list = [
  8.99, // 0. High Tack Seaming Adhesive 
  1.99, //1. Jointing Tape
  1, // 2. Heavy Duty Weed Control Fabric Membrane
  2.99, // 3. Weed Fabric Fixing Pegs
  4.99, // 4. Galvanised Green Staple Pegs
  9.99, // 5. 2-Part PU Adhesive
  9.99, // 6. Galvinised Green Nails
  6.99, // 7. 10mm Artificial Grass Underlay
  9.99, // 8. 15mm Artificial Grass Underlay
  57.99 // 9 Underlay Adhesive
];
let wide_list = [];
let last_divide_factor = false;

let clip_flag = Array(9).fill(0); // 0 is disabled, 1 is enabled
let page_flag = 1; // product page 0 and calculator page 1 

function setWideList() {
  wide_list = [];
  last_divide_factor = false;

  
if (Array.isArray(collections_list)) {
  collections_list.forEach((collection) => {
    const c = collection.toLowerCase();
    if (
      (c === "5m wide artificial grass manchester" || c === "5m wide artificial grass" || c === "5m wide wall grass") &&
      !wide_list.includes(5)
    ) {
      wide_list.push(5);
    } else if (
      (c === "4m wide artificial grass" || c === "4m wide wall grass") &&
      !wide_list.includes(4)
    ) {
      wide_list.push(4);
    } else if (
      (c === "3m wide artificial grass" || c === "3m wide wall grass") &&
      !wide_list.includes(3)
    ) {
      wide_list.push(3);
    } else if (
      (c === "2m wide artificial grass" || c === "2m wide wall grass") &&
      !wide_list.includes(2)
    ) {
      wide_list.push(2);
    } else if (
      (c === "1m wide artificial grass" || c === "1m wide wall grass") &&
      !wide_list.includes(1)
    ) {
      wide_list.push(1);
    }
  });
  wide_list = wide_list.slice().sort((a, b) => b - a);
} else {
  console.error("collections_list is not an array");
}


  // if (Array.isArray(collections_list)) {
  //   collections_list.forEach((collection) => {
  //     if (collection === "5M Wide Artificial Grass Manchester" && !wide_list.includes(5)) {
  //       wide_list.push(5);
  //     } else if (collection === "5M Wide Wall Grass" && !wide_list.includes(5)) {
  //       wide_list.push(5);
  //     } else if (collection === "5m Wide Wall Grass" && !wide_list.includes(5)) {
  //       wide_list.push(5);
  //     } else if (collection === "4M Wide Artificial Grass" && !wide_list.includes(4)) {
  //       wide_list.push(4);
  //     } else if (collection === "3M Wide Artificial Grass" && !wide_list.includes(3)) {
  //       wide_list.push(3);
  //     } else if (collection === "2M Wide Artificial Grass" && !wide_list.includes(2)) {
  //       wide_list.push(2);
  //     } else if (collection === "1M Wide Artificial Grass" && !wide_list.includes(1)) {
  //       wide_list.push(1);
  //     }
  //   });
  //   wide_list = wide_list.slice().sort((a, b) => b - a);
  // } else {
  //   console.error("collections_list is not an array");
  // }

  if (
    wide_list[wide_list.length - 1] > 2 &&
    m_width > wide_list[wide_list.length - 1]
  ) {
    wide_list.push(wide_list[wide_list.length - 1] / 2);
    last_divide_factor = true;
  }
}

function setCollectionLabel() {
  var labelTxt = "";
  var twide_list = [...wide_list];
  twide_list.sort();
  twide_list.forEach((wide, index) => {
    if (index < twide_list.length - 2) {
      labelTxt += wide + "m, ";
    } else if (index < twide_list.length - 1) {
      labelTxt += wide + "m & ";
    } else {
      labelTxt += wide + "m ";
    }
  });
  $("#product-collections").text("Available in " + labelTxt + "wide");
}

function setSelectedUnit(unit) {
  munit = unit;
  $(".unit-btn").removeClass("selected");

  if (munit === 1) {
    t_scale = 1;
    // METRES
    $("#metres-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
  } else if (munit === 2) {
    t_scale = 0.0254;
    // FEET
    $("#feet-btn").addClass("selected");
    $("#input-row-1").hide();
    $("#input-row-2").show();
  } else if (munit === 3) {
    t_scale = 0.01;
    // CENTEMETRES
    $("#centimetres-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
  } else if (munit === 4) {
    // INCHES
    t_scale = 0.0256410256; // More accurate scale factor
    $("#inches-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
  }

  refreshData();

  if (mode == 0) {
    $("#inner").empty();
    addManualCut();
  }
}

function selectType(type_num) {
  type = type_num;
  $(".option-item").removeClass("selected");

  // Add selected class to the corresponding button
  if (type === 1) {
    $("#regular-grass").addClass("selected");
  } else if (type === 2) {
    $("#flags").addClass("selected");
  } else if (type === 3) {
    $("#decking").addClass("selected");
  } else if (type === 4) {
    $("#tarmac").addClass("selected");
  } else if (type === 0) {
    $("#none").addClass("selected");
  }
}

function calculatePrice(width, length, tapelength) {
  g_area = width * length;

  console.log("calculatePrice width", width);
  console.log("calculatePrice type", type);
  console.log("calculatePrice tapelength", tapelength);

  clip_cnt_list = Array(9).fill(0);

  
  // 0 "High Tack Seaming Adhesive",
  // 1 "Jointing Tape",
  // 2 "Heavy Duty Weed Control Fabric Membrane",
  // 3 "Weed Fabric Fixing Pegs",
  // 4 "Galvanised Green Staple Pegs",
  // 5 "2-Part PU Adhesive",
  // 6 "Galvinised Green Nails",
  // 7 "10mm Artificial Grass Underlay",
  // 8 "15mm Artificial Grass Underlay",
  // 9 "Underlay Adhesive",


  console.log("recommendProducts ", recommendProducts[0] );
    
  if(Math.ceil(tapelength) > 0){
    if (recommendProducts[0].accessories_enable__0){
      clip_cnt_list[0] = Math.ceil(tapelength / 4); // adhesive tubes
      clip_flag[0] = recommendProducts[0].accessories_required__0 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__1) {
      clip_cnt_list[1] = Math.ceil(tapelength); // Jointing Tape m
      clip_flag[1] = recommendProducts[0].accessories_required__1 ? 1 : 0;
    }
  }
  if (type === 1) {
    if (recommendProducts[0]?.accessories_enable__2) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = recommendProducts[0].accessories_required__2 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__3) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // Weed Fabric Fixing Pegs
      clip_flag[3] = recommendProducts[0].accessories_required__3 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__4) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = recommendProducts[0].accessories_required__4 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__6) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5); // Galvinised Green Nails
      clip_flag[6] = recommendProducts[0].accessories_required__6 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = recommendProducts[0].accessories_required__8 ? 1 : 0; 
    }
  } else if (type === 2) {
    if (recommendProducts[0]?.accessories_enable__5) {
      clip_cnt_list[5] = Math.ceil(g_area / 10); // 2-Part PU Adhesive
      clip_flag[5] = recommendProducts[0].accessories_required__5 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = recommendProducts[0].accessories_required__8 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__9) {
      clip_cnt_list[9] = Math.ceil(g_area / 10); // Underlay Adhesive
      clip_flag[9] = recommendProducts[0].accessories_required__9 ? 1 : 0; 
    }
  } else if (type === 3) {
    if (recommendProducts[0]?.accessories_enable__6) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5);
      clip_flag[6] = recommendProducts[0].accessories_required__6 ? 1 : 0; 
    }    
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = recommendProducts[0].accessories_required__8 ? 1 : 0; 
    }
  } else if (type === 4) {
  } else if (type === 0) {
    if (recommendProducts[0]?.accessories_enable__2) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = recommendProducts[0].accessories_required__2 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__3) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = recommendProducts[0].accessories_required__3 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__4) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = recommendProducts[0].accessories_required__4 ? 1 : 0; 
    }
    
    if (recommendProducts[0]?.accessories_enable__6) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5); // Galvinised Green Nails
      clip_flag[6] = recommendProducts[0].accessories_required__6 ? 1 : 0; 
    }
    
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0; 
    }
    
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = recommendProducts[0].accessories_required__8 ? 1 : 0; 
    }
  }

  showQuote();
}

function calculatePrice2(area, tapelength, around) {
  g_area = area;

  clip_cnt_list = Array(9).fill(0);
  
  if(Math.ceil(tapelength) > 0){
    if (recommendProducts[0].accessories_enable__0){
      clip_cnt_list[0] = Math.ceil(tapelength / 4); // adhesive tubes
      clip_flag[0] = recommendProducts[0].accessories_required__0 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__1) {
      clip_cnt_list[1] = Math.ceil(tapelength); // Jointing Tape m
      clip_flag[1] = recommendProducts[0].accessories_required__1 ? 1 : 0;
    }
  }
  
  if (type === 1) {
    if (recommendProducts[0]?.accessories_enable__2) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = recommendProducts[0].accessories_required__2 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__3) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = recommendProducts[0].accessories_required__3 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__4) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = recommendProducts[0].accessories_required__4 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = recommendProducts[0].accessories_required__8 ? 1 : 0;
    }
    // clip_cnt_list[9] = Math.ceil(g_area); //Underlay Adhesive
    // clip_flag[9] = 1;
    // clip_cnt_list[9] = Math.ceil(g_area/10);
    // clip_flag[9] = 1;
  } else if (type === 2) {
    if (recommendProducts[0]?.accessories_enable__5) {
      clip_cnt_list[5] = Math.ceil(g_area / 10); // 2-Part PU Adhesive
      clip_flag[5] = recommendProducts[0].accessories_required__5 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = recommendProducts[0].accessories_required__8 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__9) {
      clip_cnt_list[9] = Math.ceil(g_area / 10); //Underlay Adhesive
      clip_flag[9] = recommendProducts[0].accessories_required__9 ? 1 : 0;
    }
      // clip_cnt_list[9] = Math.ceil(g_area); //Underlay Adhesive
      // clip_flag[9] = 1;
      // clip_cnt_list[9] = Math.ceil(g_area/10);
      // clip_flag[9] = 1;
  } else if (type === 3) {
    if (recommendProducts[0]?.accessories_enable__6) {
      clip_cnt_list[6] = Math.ceil(g_area / 5); // Galvinised Green 
      clip_flag[6] = recommendProducts[0].accessories_required__6 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = recommendProducts[0].accessories_required__8 ? 1 : 0;
    }    
    // clip_cnt_list[7] = Math.ceil(g_area / 10); // HP - 2021-07-19
    // clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
    // clip_flag[7] = 1;
    // clip_cnt_list[9] = Math.ceil(g_area); //Underlay Adhesive
    // clip_flag[9] = 1;
    // clip_cnt_list[9] = Math.ceil(g_area/10);
    // clip_flag[9] = 1;
  } else if (type === 4) {
  } else if (type === 0) {
    // clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
    // clip_flag[2] = 1;
    // clip_cnt_list[3] = Math.ceil(g_area / 20); // Weed Fabric Fixing Pegs
    // clip_flag[3] = 1;
    // clip_cnt_list[4] = Math.ceil(g_area / 10); // Weed Fabric Fixing Pegs
    // clip_flag[4] = 1;
    // // clip_cnt_list[7] = Math.ceil(g_area / 10); // HP - 2021-07-19
    // clip_cnt_list[7] = Math.ceil(g_area / 10); // 10mm Artificial Grass Underlay
    // clip_flag[7] = 1;
    // // clip_cnt_list[9] = Math.ceil(g_area); // Underlay Adhesive
    // // clip_flag[9] = 1;
    // // clip_cnt_list[9] = Math.ceil(g_area/10);
    // // clip_flag[9] = 1;

    
    if (recommendProducts[0]?.accessories_enable__2) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = recommendProducts[0].accessories_required__2 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__3) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = recommendProducts[0].accessories_required__3 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__4) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = recommendProducts[0].accessories_required__4 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      // clip_cnt_list[7] = Math.ceil(g_area / 10); // HP - 2021-07-19
      clip_cnt_list[7] = Math.ceil(g_area); //10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); //15mm Artificial Grass Underlay
      clip_flag[8] = recommendProducts[0].accessories_required__8 ? 1 : 0;
    }
    // clip_cnt_list[9] = Math.ceil(g_area); // Underlay Adhesive
    // clip_flag[9] = 1;
    // clip_cnt_list[9] = Math.ceil(g_area/10);
    // clip_flag[9] = 1;
  }

  showQuote();
}

function showQuote() {
  let total_grass_price = g_area * p_price;
  $("#grass-price").text(p_price);
  // $("#total-area").text(Math.ceil(g_area));
  $("#total-area").text(g_area);
  $("#cost-of-grass").text(total_grass_price.toFixed(2));

  var clips_total_price = 0;
  var clip_quote_view = $("#clip-quote-view");
  clip_quote_view.empty();



  for (let i = 0; i < clip_id_list.length; i++) {
    if (clip_cnt_list[i] > 0) {
      var rowDiv = $("<div>", { class: "row" }).attr("id", "clip-row-" + i);
      // if( clip_flag[i] ===)

      console.log("clip_flag[i]", clip_flag[i]);
      
      var pTag1 = $("<p>").html(
        clip_title_list[i] +
          " (" +
          clip_cnt_list[i] +
          " " +
          clip_unit_list[i] +
          ")"
      );
      var pTag2 = $("<p>", { class: "price" }).text(
        "£" + (clip_cnt_list[i] * clip_price_list[i]).toFixed(2)
      );
      var btnTag = $("<button>")
        .attr("id", "rmv-btn-" + i)
        .addClass("rmv-btn")
        .text("")
        .on("click", function () {
          removeClipBtnClick(i);
        });
      var tagDiv = $("<div>", { class: "tag-group" });

      tagDiv.append(pTag1);
      tagDiv.append(pTag2);
      rowDiv.append(tagDiv);

      if (clip_flag[i] === 0) {
        rowDiv.addClass("clip-row-disable");
        btnTag.text("×");
      } else if (clip_flag[i] == 1) {
        clips_total_price += clip_cnt_list[i] * clip_price_list[i];
        btnTag.html(`<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tick" 
          viewBox="0 0 515.556 515.556" width="26" height="26">
            <path d="M0 274.226l176.549 176.886L515.556 112.44l-48.67-47.997-290.337 290L47.996 225.891z"></path>
          </svg>`);
      }
      rowDiv.append(btnTag);

      clip_quote_view.append(rowDiv);
    }
  }

  $("#accessory-total-price").text(clips_total_price.toFixed(2));
  $("#final-total-grass").text("£" + total_grass_price.toFixed(2));
  $("#final-total").text(
    "£" + (clips_total_price + total_grass_price).toFixed(2)
  );
  

  // Corrected click event binding
  // if ($("#rmv-btn-8").length) {
  //   setTimeout(function() {
  //     removeClipBtnClick(8);
  //   }, 100); // Executes after 2 seconds
  // }
}

function removeClipBtnClick(index) {
  if (clip_flag[index] == 0) {
    clip_flag[index] = 1;
  } else if (clip_flag[index] == 1) {
    clip_flag[index] = 0;
  }

  // console.log(clip_flag);

  if (clip_flag.every((item) => item === 0)) {
    $("#check-out-btn-1").hide();
  } else {
    $("#check-out-btn-1").show();
  }

  showQuote();
}

function selectMode(m) {
  mode = m;
  if (m == 0) {
    $("#cal-use").removeClass("selected");
    $("#cus-use").addClass("selected");
    $("#calculator-mode").hide();
    $("#custom-cutter").show();
  } else {
    $("#cal-use").addClass("selected");
    $("#cus-use").removeClass("selected");
    $("#calculator-mode").show();
    $("#custom-cutter").hide();
  }

  refreshData();
}

function calculateGrassRolls(width, max) {
  let results = [];

  if (width <= 0) {
    return { cap: width, widecut: [], step: 0, cover: 0 };
  }

  // console.log("wide_list", wide_list);
  // console.log("wide_list.length", wide_list.length);
  // console.log("max", max);

  for (let i = 0; i < wide_list.length; i++) {
    if (wide_list[i] <= max) {
      let result = calculateGrassRolls(width - wide_list[i], wide_list[i]);
      // console.log("result -- is --",{ result: result, wide: wide_list[i] });
      results.push({ result: result, wide: wide_list[i] });
    }
  }

  let bestResult = results[0].result;
  let chooseWide = results[0].wide;

  for (let i = 1; i < results.length; i++) {
    if (results[i].result.cap > bestResult.cap) {
      bestResult = results[i].result;
      chooseWide = results[i].wide;
    } else if (results[i].result.cap === bestResult.cap) {
      // Fixed comparison
      if (results[i].result.step < bestResult.step) {
        bestResult = results[i].result;
        chooseWide = results[i].wide;
      }
    }
  }

  bestResult.widecut.unshift(chooseWide);
  bestResult.step++;
  bestResult.cover += chooseWide;

  return bestResult;
}

function drawGrassPlan(
  canvasId,
  width,
  length,
  key_box_id = "#key-box",
  key_box_2_id = "#key-box-2",
  canvasWidth = 400,
  canvasHeight = 250
) {
  let canvas = document.getElementById(canvasId);
  let context = canvas.getContext("2d");
  let length_label = length;

  let result = calculateGrassRolls(width, wide_list[0]);

  // Calculate the grass rolls
  let rolls = result.widecut;

  // rolls = rolls.map(num => num + 1);

  if (rolls.length >= 2) {
    $(key_box_id).show();
  } else {
    $(key_box_id).hide();
  }

  // console.log("calculatePrice result.cover", result.cover);
  // console.log("calculatePrice length", length);
  // console.log("calculatePrice rolls", rolls);
  
  calculatePrice(result.cover, length, length * (rolls.length - 1));

  width = result.cover + rolls.length * 1;

  // console.log(last_divide_factor, wide_list, rolls);

  if (
    rolls[rolls.length - 1] == wide_list[wide_list.length - 1] &&
    last_divide_factor == true
  ) {
    last_divide_factor = true;
  } else {
    last_divide_factor = false;
  }

  // console.log("last_divide_factor", last_divide_factor);

  if (last_divide_factor) {
    $(key_box_2_id).show();
  } else {
    $(key_box_2_id).hide();
  }

  let scaleX = canvasWidth / width;
  let scaleY = canvasHeight / length;
  const scale = Math.min(scaleX, scaleY); // Use the smaller scale to ensure the entire area fits

  if (scaleY <= scaleX / 2) {
    scaleX = scale * 2;
  } else if (scaleX <= scaleY / 2) {
    scaleY = scale * 2;
  } else {
    scaleX = scale;
    scaleY = scale;
  }

  width *= scaleX;
  length *= scaleY;

  canvas.width = width;
  canvas.height = length;

  // Initialize position for drawing
  let currentX = 0;
  let dashX;
  let dashY;

  // Draw each roll
  rolls.forEach((roll, index) => {
    context.fillStyle = "#95C11F99";
    context.fillRect(currentX, 0, (roll + 1) * scaleX, length);

    context.fillStyle = "#FFFFFF";
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.font = `${scale * 0.01 * 16 + 10}px Arial`;

    if (index < rolls.length - 1 || !last_divide_factor) {
      let textY = length / 2;

      const textX = currentX + ((roll + 1) * scaleX) / 2;
      const delta = scaleY * 0.011 * 16 * 1.1 + 12;

      // Draw each line of text
      context.fillText(`${length_label}m`, textX, textY - delta);
      context.fillText("x", textX, textY);
      context.fillText(`${roll}m`, textX, textY + delta);
    }

    currentX += (roll + 1) * scaleX;
  });

  currentX = 0;

  rolls.forEach((roll, index) => {
    // Starting point for the dashed line
    dashX = currentX + (roll + 1) * scaleX;
    dashY = 0;

    // Set line style
    context.strokeStyle = "#000";
    context.lineWidth = 2; // Adjust line width as needed

    // Draw the dashed line
    while (dashX < width && dashY < length) {
      context.beginPath();
      context.moveTo(dashX, dashY);
      context.lineTo(dashX, dashY + 6);
      context.stroke();
      dashY += 6 + 3;
    }

    currentX += (roll + 1) * scaleX;
  });

  if (last_divide_factor) {
    let roll = rolls[rolls.length - 1];

    dashX = width - (roll + 1) * scaleX;
    dashY = length / 2;
    // Set line style
    context.strokeStyle = "#000";
    context.lineWidth = 2; // Adjust line width as needed

    // Draw the dashed line
    while (dashX < width) {
      context.beginPath();
      context.moveTo(dashX, dashY);
      context.lineTo(dashX + 6, dashY);
      context.stroke();
      dashX += 6 + 3;
    }

    context.fillStyle = "#FFFFFF";
    context.font = `${scale * 0.01 * 16 + 10}px Arial`;
    context.textAlign = "center";
    context.textBaseline = "middle";
    let textY = length / 4;
    let textX = width - ((roll + 1) / 2) * scaleX;
    let delta = scaleY * 0.011 * 16 * 1.1 + 12; // Adjust y-coordinate for first line
    context.fillText(`${length_label / 2}m`, textX, textY - delta);
    context.fillText("x", textX, textY);
    context.fillText(`${roll}m`, textX, textY + delta);
    textY = (length * 3) / 4;
    context.fillText(`${length_label / 2}m`, textX, textY - delta);
    context.fillText("x", textX, textY);
    context.fillText(`${roll}m`, textX, textY + delta);
  }
}

function addtoCart(with_clips) {
  var productsToAdd = [{ id: g_id, quantity: Math.ceil(g_area) }];

  if (with_clips == true) {
    for (i = 0; i < clip_id_list.length; i++) {
      if (clip_cnt_list[i] > 0 && clip_flag[i] == 1) {
        productsToAdd.push({
          id: clip_id_list[i],
          quantity: clip_cnt_list[i],
        });
      }
    }
  }

  let formData = {
    items: productsToAdd,
  };

  let cartResponse = fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      $("input, button, select").prop("disabled", false);
      window.location.href = "https://grasscashandcarry.co.uk/cart";
      return response.json();
    })
    .catch((error) => {
      alert("Products are not added on your cart!");
      console.error("Error:", error);
    });
}

function unitText(flag = 0) {
  if (munit === 1) {
    return ["m"];
  } else if (munit === 2) {
    return ["ft", (flag == 0)?"inches":"in"];
  } else if (munit === 4) {
    return ["in", (flag == 0)?"inches":"in"];
  } else {
    return ["cm"];
  }
}

function addManualCut() {
  var $cutRow = $("<div>")
    .attr("id", "cus-row-" + manual_cut)
    .addClass("cut-row cut-row-" + manual_cut);

  var $lengthInput;

  if (munit === 2) {
    var $lengthInput = $("<div>").attr({
      id: "cutter-length-group-" + manual_cut,
      class: "cutter-length-group",
    });
    var $feetInput = $("<input>").attr({
      id: "cutter-length-" + manual_cut + "-f",
      listener: "true",
      name: "cutter-length-" + manual_cut + "-f",
      type: "number",
      step: "1",
      min: "0",
      max: "82",
      value: "",
    });

    var $inchInput = $("<input>").attr({
      id: "cutter-length-" + manual_cut + "-i",
      listener: "true",
      name: "cutter-length-" + manual_cut + "-i",
      type: "number",
      step: "1",
      min: "0",
      max: "11",
      value: "",
    });

    $lengthInput.append($feetInput);
    $lengthInput.append($("<p>").html("ft"));
    $lengthInput.append($inchInput);
    $lengthInput.append($("<p>").html("in"));

    $feetInput.on("input", function () {
      calManualCutValue();
    });

    $inchInput.on("input", function () {
      if ($(this).val() > 11) {
        $(this)
          .parent()
          .children()
          .first()
          .val(
            ($(this).parent().children().first().val() || 0) +
              Math.floor($(this).val() / 12)
          );
        $(this).val($(this).val() % 12);
      }
      calManualCutValue();
    });
  } else {
    $lengthInput = $("<div>").attr({
      id: "cutter-length-group-" + manual_cut,
      class: "cutter-length-group",
    });
    var $lInput = $("<input>")
      .attr({
        id: "cutter-length-" + manual_cut,
        listener: "true",
        name: "cutter-length-" + manual_cut,
        type: "number",
        step: "1",
        min: "0",
        max: Math.ceil(25 / t_scale),
        value: "",
      })
      .on("input", function () {        
        
          console.log("munit", munit);
          console.log("t_scale", t_scale);
          console.log("this value", $(this).val());
        
        if ($(this).val() > 25 / t_scale) {
          $(this).val(Math.floor(25 / t_scale));
          $("#cus-cut-warning").show();          
        } else if ( munit === 1 && $(this).val() < 1) {
          $("#cus-cut-warning").show();
        } else if ( munit === 3 && $(this).val() < 100) {
          $("#cus-cut-warning").show();
        } else {
          $("#cus-cut-warning").hide();
        }
        calManualCutValue();
      });

    $lengthInput.append($lInput);
  }

  var $btnTag = $("<button>")
    .attr("id", "cus-rmv-btn-" + manual_cut)
    .addClass("rmv-btn")
    .text("×")
    .on("click", function () {
      $cutRow.remove();
      calManualCutValue();
      manual_cut--;
    });

  var $widthSelect = $("<select>")
    .attr({
      id: "SingleOptionSelector-" + manual_cut,
      "data-single-option-selector": "",
      "data-index": "option1",
      listener: "true",
    })
    .addClass("single-option-selector width_select")
    .on("input", function () {
      calManualCutValue();
    });

  var twide_list = [...wide_list];
  twide_list.sort();

  // twide_list.forEach((wide, index) => {
  //   var label;
  //   if (munit === 2) {
  //     label =
  //       Math.floor(wide / t_scale / 12) +
  //       unitText(page_flag)[0] +
  //       " " +
  //       Math.round(wide / t_scale - Math.floor(wide / t_scale / 12) * 12) +
  //       unitText(page_flag)[1];
  //   } else {
  //     label = Math.ceil(wide / t_scale) + unitText(page_flag)[0];
  //   }
  //   $widthSelect.append($("<option>").attr("value", wide).text(label));
  // });
  
  twide_list.forEach((wide) => {
    let label;
  
    if (munit === 2) {
      const feet = Math.floor(wide / t_scale / 12);
      const inches = Math.round(wide / t_scale - feet * 12);
      const unitTextParts = unitText(page_flag);
  
      label = `${feet}${unitTextParts[0]} ${inches}${unitTextParts[1]} (${wide}m)`;
    } else if (munit === 3) {
      label = `${Math.ceil(wide / t_scale)}${unitText(page_flag)[0]} (${wide}m)`;
    } else if (munit === 4) {
      label = `${Math.round(wide / t_scale)}${unitText(page_flag)[0]} (${wide}m)`;
    } else {
      label = `${Math.ceil(wide / t_scale)}${unitText(page_flag)[0]}`;
    }
  
    $widthSelect.append($("<option>").attr("value", wide).text(label));
  });



  $widthSelect.val($widthSelect.find("option:first").val());

  $cutRow.append($btnTag);
  $cutRow.append($lengthInput);
  $cutRow.append($widthSelect);

  // Finally, append the entire structure to the target element
  $("#inner").append($cutRow);

  manual_cut++;

  calManualCutValue();
}

function calManualCutValue() {
  g_area = 0;
  manual_cut_tapelength = 0;
  let first_length = 0;  // Declare `first_length` outside the loop

  $("#custom-cutter #inner .cut-row").each(function (index) {
    var length;      

    // console.log("index", index);
    // console.log("this", this);

    if( index === 0){
      if (munit == 2) {
        first_length = parseFloat(
          (
            parseFloat($(this).find("input").eq(0).val() * t_scale * 12.0 +
              $(this).find("input").eq(1).val() * t_scale) || 0
          ).toFixed(1)
        );
        // console.log('Length: ', length);
      } else {
        // first_length = parseFloat(
        //   (parseFloat($(this).find("input").val()) * t_scale || 0).toFixed(1)
        // );
        
        first_length = parseFloat($(this).find("input").val());
        // console.log("first_length", first_length);
      }
    }

    // Calculate length
    if (munit == 2) {
      length = parseFloat(
        (
          parseFloat($(this).find("input").eq(0).val() * t_scale * 12.0 +
            $(this).find("input").eq(1).val() * t_scale) || 0
        ).toFixed(1)
      );
      // console.log('Length: ', length);
    } else {
      // length = parseFloat(
      //   (parseFloat($(this).find("input").val()) * t_scale || 0).toFixed(1)
      // );
      length = parseFloat($(this).find("input").val());
      console.log("length", length);
    }
    
    // Calculate length
    if (munit == 4) {
      length = parseFloat(
        (parseFloat($(this).find("input").val()) * t_scale || 0).toFixed(1)
      );
      // length = parseFloat($(this).find("input").val());
      // console.log("munit == 4 length", length);
    }

    var width = parseFloat(
      (parseFloat($(this).find("select").val()) || 0).toFixed(1)
    );

    g_area += length * width;
    manual_cut_tapelength += length;
  });

  // g_area = Math.ceil(g_area);
  g_area = g_area;
  manual_cut_tapelength = parseFloat(manual_cut_tapelength.toFixed(2)) - first_length;
  // console.log(g_area);
  // console.log("first_length", first_length);
}


function addtoCartManualCut() {
  var productsToAdd = [{ id: g_id, quantity: Math.ceil(g_area) }];

  let formData = {
    items: productsToAdd,
  };

  let cartResponse = fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      window.location.href = "/cart";
      return response.json();
    })
    .catch((error) => {
      alert("Products are not added on your cart!");
      console.error("Error:", error);
    });
}

function refreshData() {
  g_area = 0;
  m_width = 0;
  m_length = 0;
  manual_cut = 0;
  manual_cut_tapelength = 0;
  clip_flag.fill(0);

  $("#lawn-width").val("");
  $("#lawn-length").val("");
  $(
    "#quote-section, #quote-box, #quote-warning, #step-1-warning, #cus-cut-warning"
  ).hide();
  $("#checkout-warning-msg").hide();
  $("input, button, select").prop("disabled", false);
  // $("#cus-use").addClass("selected");
}

$("input").on("wheel", function (e) {
  e.preventDefault();
});

$("#lawn-length").on("input", function () {
  if ($(this).val() > 25 / t_scale) {
    this.value = (25 / t_scale).toFixed(2);
    $("#step-1-warning").show();
  } else if ($(this).val() < 1 / t_scale) {
    // $(this).val((1/t_scale).toFixed(2));
    $("#step-1-warning").show();
  } else {
    $("#step-1-warning").hide();
  }
});

$("#lawn-length").on("input", function () {});

// Unit selection
$(".unit-btn").click(function () {
  let unitID = $(this).attr("id");

  if (unitID === "metres-btn") {
    setSelectedUnit(1);
  } else if (unitID === "feet-btn") {
    setSelectedUnit(2);
  } else if (unitID === "centimetres-btn") {
    setSelectedUnit(3);
  } else if (unitID === "inches-btn") {
    setSelectedUnit(4);
  }
});

// $("#get-quote-btn").click(function () {
//   // console.log("OPEN MODEL");
//   // $('#klaviyo-form-embeed').slideDown(100);
//   $(".qc-model").addClass("is-active");
// });

// AFTER KLAVIYO FORM SUBMITTED
// $("#klaviyo-form-embeed form").submit(function (event) {
//     event.preventDefault(); // Prevent default form submission

//   alert("HELLO WORLD");

//     // var email = $("#klaviyo-email").val(); // Get email input value

//     // $.ajax({
//     //     url: `https://a.klaviyo.com/api/v2/list/YOUR_LIST_ID/subscribe`,
//     //     type: "POST",
//     //     contentType: "application/json",
//     //     data: JSON.stringify({
//     //         api_key: "YOUR_KLAVIYO_PUBLIC_API_KEY",
//     //         profiles: [{ email: email }]
//     //     }),
//     //     success: function (response) {
//     //         alert("Thank you! Your form has been submitted successfully.");
//     //     },
//     //     error: function (error) {
//     //         alert("Oops! Something went wrong.");
//     //         console.error("Klaviyo Error:", error);
//     //     }
//     // });
// });


// $(document).on("click", "#QCModalForm .get-quote-submit", function (event) {
//   event.preventDefault(); // Prevent the default form submission

  
//   const myForm = document.querySelector('#QCModalForm');

//   window.Shopify.captcha.protect(myForm, () => {
//     myForm.submit();
    
//   // Perform validation
//   const firstName = $("#QCModalForm-firstName").val().trim();
//   const email = $("#QCModalForm-email").val().trim();
//   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//   let isValid = true;

//   // Validate First Name
//   if (firstName === "") {
//     isValid = false;
//     alert("Please enter your first name.");
//     $("#QCModalForm-firstName").focus();
//     return;
//   }

//   // Validate Email
//   if (email === "" || !emailPattern.test(email)) {
//     isValid = false;
//     alert("Please enter a valid email address.");
//     $("#QCModalForm-email").focus();
//     return;
//   }

//   // If validation passes, submit the form via AJAX
//   if (isValid) {
//     const formData = {
//       firstName: firstName,
//       email: email,
//     };

//     // Send the form data to Shopify's contact form endpoint
//     $.ajax({
//       type: "POST",
//       url: "/contact", // Shopify's contact form endpoint
//       data: {
//         "form_type": "contact",
//         "contact[firstName]": formData.firstName,
//         "contact[email]": formData.email,
//       },
//       success: function (response) {
//         console.log("Form submitted successfully!");
//         console.log("Response:", response);

//         // Close the modal after submission
//         $(".qc-model").removeClass("is-active");

//         // Optionally, reset the form
//         $("#QCModalForm")[0].reset();

//         // Show a success message to the user
//         alert("Thank you! Your form has been submitted successfully.");
//       },
//       error: function (xhr, status, error) {
//         console.error("Form submission failed:", error);
//         alert("Something went wrong. Please try again.");
//       },
//     });
//   }
//   });
// });

// $(document).on("submit", "#QCModalForms", function (event) {
//     event.preventDefault(); // Prevent default form submission

//     let form = document.querySelector("#QCModalForms"); // Fix form ID
//     let email = form.querySelector('input[name="email"]').value.trim();
//     let first_name = form.querySelector('input[name="first_name"]').value.trim();

//     if (!email) {
//         alert("Please enter a valid email address.");
//         return;
//     }

//   console.log("Email", email);
//   console.log("first_name", first_name);

//     $.ajax({
//         url: "https://a.klaviyo.com/api/v2/list/XUYpkE/subscribe",
//         type: "POST",
//         contentType: "application/json",
//         data: JSON.stringify({
//             api_key: "pk_d6c49368dc976e53b76c311d96ad999bd8",
//             profiles: [{
//                 email: email,
//                 first_name: first_name || "", // Avoid undefined values
//             }]
//         }),
//         success: function (response) {
//             alert("Thank you! Your form has been submitted successfully.");
//             form.reset(); // Reset form after successful submission
//         },
//         error: function (error) {
//             alert("Oops! Something went wrong. Please try again.");
//             console.error("Klaviyo Error:", error);
//         }
//     });
// });




// $(document).on("submit", "#QCModalForms", function (event) {
//   event.preventDefault(); // Prevent default form submission
  
//   let form = document.querySelector("#QCModalForm");
//   let email = form.querySelector('input[name=email]');
//   let first_name = form.querySelector('input[name=first_name]');

//   console.log("formData email:", email);
//   console.log("formData first_name:", first_name);
//   // console.log("Submitting form...");

// //   // fetch(action, {
// //   //   method: "POST",
// //   //   body: urlEncodedData,
// //   //   headers: {
// //   //     "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
// //   //     "Accept": "text/html, */*; q=0.01",
// //   //     "X-Requested-With": "XMLHttpRequest"
// //   //   }
// //   // })
// //   //   .then((response) => response.text()) // Convert response to text
// //   //   .then((data) => {
// //   //     console.log("Response Data:", data);
// //   //   })
// //   //   .catch((err) => {
// //   //     console.error("Fetch Error:", err);
// //   //   });
  
// });


$("#get-quote-btn").click(function () {
  
  if (wide_list.length == 0) {
    $('#wide-sel-warning').show();
    return;
  } else {
    $('#wide-sel-warning').hide();
  }
  if (mode == 1) {
    if (munit == 2) {
      m_width = parseFloat(
        (
          12 * t_scale * $("#lawn-width-2-f").val() +
          t_scale * $("#lawn-width-2-i").val()
        ).toFixed(1)
      );
      m_length = parseFloat(
        (
          12 * t_scale * $("#lawn-length-2-f").val() +
          t_scale * $("#lawn-length-2-i").val()
        ).toFixed(1)
      );
    } else {
      m_width = parseFloat((t_scale * $("#lawn-width").val()).toFixed(1));
      m_length = parseFloat((t_scale * $("#lawn-length").val()).toFixed(1));
    }

    // console.log(munit, "logging:", m_width, m_length);

    if (m_length > 25) {
      m_length = 25;
    }

    if (m_width >= 1 && m_length >= 1 && m_length <= 25) {
      
      if(m_width * m_length == 0){
        return ;
      }
    
      
      $("#step-1-warning").hide();
      $("#quote-title").text(
        "Your measurements (" + m_length + "m × " + m_width + "m)"
      );
      $("#quote-section, #quote-box").show();
      drawGrassPlan(
        "grassCanvas",
        m_width,
        m_length,
        "#key-box",
        "#key-box-2",
        $(".result-box").first().width() - 60,
        $(".result-box").first().height() - 60
      );
      document.getElementById("quote-section").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      $("#step-1-warning").show();
      $("#quote-box").hide();
    }
  } else {
    calManualCutValue();
    // console.log("calculatePrice2");
      
    // console.log("calculatePrice g_area", g_area);
    // console.log("calculatePrice munit", munit);
    // console.log("calculatePrice manual_cut_tapelength", manual_cut_tapelength);
    // console.log("calculatePrice manual_cut_tapelength", manual_cut_tapelength);
    
    calculatePrice2(g_area, manual_cut_tapelength, manual_cut_tapelength);
    
    if(g_area == 0){
      return ;
    }
  
    $("#quote-box").show();
    document.getElementById("quote-box").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }
  // console.log('Width: ', m_width, 'Height: ', m_length);
});

$("#check-out-btn-1").click(function () {
  if (g_ok) {
    $("input, button, select").prop("disabled", true);
    addtoCart(true);
    // Once all products are added to the cart, redirect to the checkout page
    // window.location.href = "https://grasscashandcarry.co.uk/cart";
  } else {
    $("#checkout-warning-msg").show();
  }
});

$("#check-out-btn-0").click(function () {
  if (g_ok) {
    $("input, button, select").prop("disabled", true);
    addtoCart(false);
    // Once all products are added to the cart, redirect to the checkout page
    // window.location.href = "https://grasscashandcarry.co.uk/cart";
  } else {
    $("#checkout-warning-msg").show();
  }
});

// Type selection
$(".option-item").click(function () {
  let id = $(this).attr("id");

  // Handle type selection
  if (id === "regular-grass") {
    selectType(1);
  } else if (id === "flags") {
    selectType(2);
  } else if (id === "decking") {
    selectType(3);
  } else if (id === "tarmac") {
    selectType(4);
  } else if (id === "none") {
    selectType(0);
  }

  $("#get-quote-btn").click(); // Trigger click on #get-quote-btn
});


$("#cutter-add").click(function (event) {
  addManualCut();
});

$("#cal-use").click(function () {
  selectMode(1);
});

$("#cus-use").click(function () {
  $("#inner").empty();
  addManualCut();
  selectMode(0);
});

$("#lawn-length-2-i, #lawn-width-2-i").on("input", function () {
  if ($(this).val() > 11) {
    $(this)
      .parent()
      .children()
      .first()
      .val(
        parseFloat($(this).parent().children().first().val() || 0) +
          Math.floor($(this).val() / 12)
      );
    $(this).val($(this).val() % 12);
  }
});

function init() {
  refreshData();

  setSelectedUnit(1);
  selectType(1);

  $("#inner").empty();
  addManualCut();
  $("#quote-calculator").show();
  $("#calculator-mode").hide();
  selectMode(0);
}

setWideList();

setCollectionLabel();
// Initialize
init();
